import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { ModalService } from '@common_libraries/controls/modal/services/modal.service';

@Injectable({providedIn: 'root'})
export class DeactivateDialogService {
  private dialogConfirmSubj = new Subject<boolean>();

  constructor(public modalService: ModalService) { }

  confirm(): Observable<boolean> {
    this.modalService.open('deactivate-route-confirm');
    return this.dialogConfirmSubj.asObservable();
  }

  dialogConfirm(confirm: boolean) {
    this.dialogConfirmSubj.next(confirm);
  }
}
